import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3cbe9593"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "loader" };
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, EXCEPTIONS } = useMessage();
        const refresh = () => {
            location.reload();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(_unref(format)(_unref(EXCEPTIONS).REFRESH)) + " ", 1),
                _createElementVNode("label", {
                    class: "refresh",
                    onClick: refresh
                }, _toDisplayString(_unref(format)(_unref(EXCEPTIONS).REFRESH_BUTTON)), 1)
            ]));
        };
    }
});
